import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

function PastSixMonths(props: any) {

    ChartJS.register( CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend );
	
	const yText = (props.isChecked) ? '฿' : 'KWh';
	const { t, i18n } = useTranslation(); 

	const chartDataBar = {
		labels: props.labels,
		backgroundColor:'#f5f5f5',
		datasets: [
			{
				label: "Green attributes (kWh) ",
				data: props.tradeData,
				backgroundColor: [
					'#006837',
				],
				borderColor: [
					'#006837',
				],
				borderWidth: 1,
                borderRadius: 5,
			},
			{
				label: "Unfilled load (kWh) ",
				data: props.energyLoadData,
				backgroundColor: [
					'#e16838',
				],
				borderColor: [
					'#e16838',
				],
				borderWidth: 1,
                borderRadius: 5,
			},
		]
	};

	const chartOptionsBar: ChartOptions<'bar'> = {
		responsive: true,
		// maintainAspectRatio:false,
		interaction:{
			mode:'index',
		},
		scales:{
			x:{
				stacked: true,
				grid:{
					display:false
				}
			},
			y:{
				stacked: true,
				title:{
					display:true,
					text:yText,
					// text:"KWh",
					align:'end',
				},
				grid:{
					borderDash:[2, 2]
				}
			}
		},
		plugins: {
			legend: {
				position: 'top',
				align:'end',
				labels: {
					usePointStyle: true,
					padding:20,
					// textAlign: 'end',
					font: {
                        size: 16,
						family:'Montserrat',
                    }
				},
			},
		}
	};

    return(
        <div><Bar data={chartDataBar} options={chartOptionsBar} className="PastSixMonths" /></div>
    )

}
export default PastSixMonths;